import { InjectionToken } from '@angular/core';

import { LanguageSwitcherMenuData } from './language-switcher.models';

/**
 * @internal
 */
export const LANGUAGE_SWITCHER_MENU_DATA = new InjectionToken<LanguageSwitcherMenuData>('vn-language-switcher-menu-data');
